<template>
  <page>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div v-if="success">
            <h1 class="mt-4 py-3 text-center font-weight-bold text-uppercase">Thank you</h1>
            <p>Thank you for filing the Form 4868. Your payment of ${{amountDollars}} was successful and we'll
            begin working on your case now. Your order number is <b>{{confirmation.id}}</b>.
            Please check your other order details below:</p>

            <div class="order-details__panel mt-5 mb-4">
              <h3 class="text-center font-weight-bold mb-4">
                Your Order Details - {{confirmation.id}}
              </h3>
              <div class="row">
                <div class="col-12 col-sm-6">
                  <div class="info-block">
                    <div class="info-label">Name</div>
                    <div class="info-value">{{confirmation.firstName}} {{confirmation.lastName}}</div>
                  </div>
                  <div class="info-block">
                    <div class="info-label">Email</div>
                    <div class="info-value">{{confirmation.email}}</div>
                  </div>
                  <div class="info-block" v-if="!!confirmation.phone">
                    <div class="info-label">Phone Number</div>
                    <div class="info-value">{{confirmation.phone}}</div>
                  </div>
                  <div class="info-block">
                    <div class="info-label">Order Date</div>
                    <div class="info-value">{{formatDate(confirmation.createdDate)}}</div>
                  </div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="info-block">
                    <div class="info-label">Address</div>
                    <div class="info-value">
                      <div>{{confirmation.address1}}</div>
                      <div>{{confirmation.address2}}</div>
                      <div>{{confirmation.city}},</div>
                      <div>{{confirmation.state}} {{confirmation.zip}}</div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="explanation">
              <p>
                As soon as tax return extension request will be approved by IRS we will send you a notification email.
                If any of the information above is incorrect, please use our contact form now to let us know so we can
                update it right away.
              </p>
              <p>
                Your application will be reviewed for any errors and transmitted securely to the IRS electronically.
              </p>
              <!--p>You can get updates by entering your order number and phone number into the order tracker on our homepage.</p-->
            </div>
          </div>
          <div v-if="!success">
            <p>Error occurred while trying to get order confirmation info.</p>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
  import moment from 'moment';
  import { AXIOS } from '../scripts/http-common'
  import { hashEmail, hashPhone, cleanupAddress, hashAddress, cleanupPostalCode } from "../scripts/gtag-common";
  import pick from "lodash/pick";

  export default {
    data() {
      return {
        confirmation: {
          id: '',
          firstName: '',
          lastName: '',
          phone: '',
          email: '',
          amount: '',
          createdDate: null,
          status: '',
        },
        shareasaleSSCID:'',
        success: true
      }
    },
    computed: {
      amountDollars() {
        if (this.confirmation.amount) {
          return parseInt(this.confirmation.amount) / 100;
        } else {
          return 0;
        }
      }
    },
    mounted() {
      AXIOS.get(`/efile/form4868/confirmation/${this.$route.params.correlationId}`)
        .then(response => {
          this.confirmation = response.data;
          this.success = true;
          const self = this;
          this.shareasaleSSCID=this.shareasaleGetCookie('shareasaleSSCID');
          console.log("shareasaleSSCID: ", this.shareasaleSSCID);

          var script=document.createElement('script');
          script.defer = true;
          script.async = true;
          script.type="text/javascript";
          script.src="https://shareasale-analytics.com/j.js";

          console.log("Amount : ",this.amountDollars);
          console.log("Order Id : ",this.confirmation.id);

          var imagetag = document.createElement('img');
              imagetag.id = "_SHRSL_img_1";
              imagetag.src = "https://www.shareasale.com/sale.cfm?tracking="+this.confirmation.id+"&amount="+this.amountDollars+"&merchantID=76439&transtype=sale&sscidmode=6&sscid="+this.shareasaleSSCID;
              imagetag.width = "1";
              imagetag.height = "1";
              imagetag.style.float = "left";

              document.getElementById('app').insertAdjacentElement("beforebegin",imagetag);
              document.getElementById('_SHRSL_img_1').insertAdjacentElement("afterend",script);

          var gtagEventConversion = {
            'send_to': 'AW-820207740/nAqzCKff6Y0BEPzAjYcD',
            'transaction_id': this.confirmation.id,
            'user_id': String(this.confirmation.userId),
            'user_data': {
              'sha256_email_address': [
                hashEmail(this.confirmation.email),
              ],
              'sha256_phone_number': [
                hashPhone(this.confirmation.phone),
              ],
              'address': [{
                'sha256_first_name': hashAddress(this.confirmation.firstName),
                'sha256_last_name': hashAddress(this.confirmation.lastName),
                'sha256_street': hashAddress(this.confirmation.address1),
                'city': cleanupAddress(this.confirmation.city),
                'region': cleanupAddress(this.confirmation.state),
                'postal_code': cleanupPostalCode(this.confirmation.zip),
                'country': 'US',
              }]
            }
          }

          console.log("GTAG EVENT CONVERSION:", gtagEventConversion);
          window.gtag('event', 'conversion', gtagEventConversion);

        })
        .catch(() => {
          this.success = false;
        })
    },
    methods: {
      shareasaleGetCookie(e) {
        var r=e+"=";
        var a=decodeURIComponent(document.cookie);
        var o=a.split(";");
        for(var n=0;n<o.length;n++)
        {var t=o[n];while(t.charAt(0)==" ")
        {t=t.substring(1)}if(t.indexOf(r)==0)
        {return t.substring(r.length,t.length)}}
        return""
      },
      formatDate(dateTimeStamp) {
        if (!dateTimeStamp) {
          return null;
        }
        return moment(dateTimeStamp).format('MMM DD, YYYY');
      },

    }
  }

</script>
<style scoped>
  .order-details__panel {
    background-color: #f5f5f5;
    padding: 30px 80px;
    position: relative;
  }
  .order-details__panel .switch-state {
    position: absolute;
    top: 20px;
    right: 100px;
    width: 200px;
    padding: 5px 10px;
    border-radius: 10px;
    background-color: #ff8525;
  }

  .switch-state a {
    color: #fff;
  }

  .switch-state a:hover {
    color: #fff;
  }

  .info-block {
    margin-bottom: 20px;
  }
  .info-label {
    font-weight: 600;
    font-size: 12px;
  }
  .info-value {
    font-size: 16px;
  }
  p {
    line-height: 2em;
    font-weight: 400;
    font-family: 'Raleway', sans-serif;
  }
  .border-line{
    border: 1px solid #0094be;
    width: 99%;
  }
  .border-arrow{
    margin-top: -0.7rem;
    color: #0094be;
    float: right;
    z-index:1
  }
</style>



// WEBPACK FOOTER //
// src/pages/Form4868Confirmation.vue